import styled from 'styled-components';

const Content = styled.div`
  padding: ${({theme}) => theme.spacingVertical(2)} ${({theme}) => theme.spacingHorizontal(2)};
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export default Content;
